import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../config/queryKeys'
import {
  getImportSeasonPlayers,
  ImportSeasonPlayersPayload,
} from '../../../services/teamBalance'

interface UseImportSeasonPlayersOptions {
  teamId: string
  rosterId: string
  registrationId: string
  /** The season picked in the dialog; null while none is. */
  seasonId: string | null
}

/**
 * Jeff, Oct 1 — one previous season's players as they stand on this sheet, and the
 * room the division leaves the team. Read fresh on every open, like the lock
 * preview: a player may have registered, or been invited, since the last look.
 */
export const useImportSeasonPlayers = ({
  teamId,
  rosterId,
  registrationId,
  seasonId,
}: UseImportSeasonPlayersOptions) => {
  const query = useQuery<ImportSeasonPlayersPayload>({
    queryKey: queryKeys.teamBalance.importSeasonPlayers(
      teamId,
      rosterId,
      registrationId,
      seasonId
    ),
    queryFn: () =>
      getImportSeasonPlayers(
        teamId,
        rosterId,
        registrationId,
        seasonId as string
      ),
    enabled:
      Boolean(teamId) &&
      Boolean(rosterId) &&
      Boolean(registrationId) &&
      seasonId !== null,
    retry: false,
    staleTime: 0,
  })

  return {
    ...query,
    players: query.data?.players ?? [],
    room: query.data?.room ?? null,
  }
}

export default useImportSeasonPlayers
